angular.module('impactx.smartform').controller('SmartFormComponentConfigurationPanelCtrl', [
    'mdPanelRef',
    '$window',
    'SmartFormTemplateCache',
    'SmartFormService',
    'ToastService',
    'ImageEditor',
    SmartFormComponentConfigurationPanelController]);

function SmartFormComponentConfigurationPanelController(mdPanelRef, $window, SmartFormTemplateCache, SmartFormService, ToastService, ImageEditor) {
    var self = this;

    (self.initOptionsString = function () {
        var resultString = '', options = impactX.isDefined(self, 'component.options');
        if (options && options.length > 0) {
            angular.forEach(options, function (entry) {
                resultString += entry.label + '\n';
            });

            self.optionsInput = resultString;
        }
    })();

    SmartFormService.getTranslations().then(function (translations) {
        self.trns = translations;
    });

    self.close = function () {
        mdPanelRef && mdPanelRef.close();
    };

    self.deleteComponent = function () {
        SmartFormTemplateCache.removeComponent(self.smartFormIdentifier, self.component.identifier);
        self.close();
        ToastService.openActionToast(SmartFormService.getTranslation('removedComponentSuccess'), SmartFormService.getTranslation('revert'), function () {
            SmartFormTemplateCache.reviveComponent()
        });
    };

    self.processOptionsInput = function () {
        if (self.optionsInput) {
            var index = 1,
                result = [],
                labels = self.optionsInput.trim().split('\n');

            angular.forEach(labels, function (label) {
                result.push({label: label, value: index});
                index++;
            });

            self.component.options = result;
        }
        else {
            self.component.options = [];
        }
        updateRadioGroup();
    };

    self.processCheckboxOptionsInput = function () {
        if (self.optionsInput) {
            var result = [],
                labels = self.optionsInput.trim().split('\n');

            angular.forEach(labels, function (label) {
                result.push({label: label, value: false});
            });

            self.component.options = result;
        }
        else {
            self.component.options = [];
        }
        updateCheckboxGroup();
    };

    self.changeSelectComponentEmptyOption = function (sourceValue) {
        if (sourceValue) {
            self.component.removeEmptyOption = sourceValue;
        }
    };

    self.changeDateComponentWeekdayFilter = function (onlyWeekdays) {
        if (onlyWeekdays) {
            self.component.onlyWeekends = false;
        }
    };

    self.changeDateComponentWeekendFilter = function (onlyWeekends) {
        if (onlyWeekends) {
            self.component.onlyWeekdays = false;
        }
    };

    self.timeChange = function (event) {
        self.component.value = event;
    }

    function updateRadioGroup() {
        if (self.component.component == 'radiogroup') {
            if (self.component.showFreeTextInputOption) {
                self.component.freeTextInputOption = {value: 0};
            }
            else {
                delete self.component.freeTextInputOption;
            }

            updateLayout();
        }
    }

    function updateCheckboxGroup() {
        if (self.component.component == 'checkboxgroup') {
            if (self.component.showFreeTextInputOption) {
                self.component.freeTextInputOption = {value: false};
            }
            else {
                delete self.component.freeTextInputOption;
            }

            updateLayout();
        }
    }

    function updateLayout() {
        var optionsLength = self.component.options.length;
        if (optionsLength > 0) {
            var offset = self.component.showFreeTextInputOption ? 2 : 1;
            self.component.layout.sizeY = optionsLength + offset;
            self.component.layout.minSizeY = optionsLength + offset;
        }
    }

    self.validateStandardMin = function () {
        if(self.component.minDate && self.component.value < self.component.minDate)
        {
            self.component.value = undefined;
        }
    }
    self.validateStandardMax = function () {
        if(self.component.maxDate && self.component.value > self.component.maxDate)
        {
            self.component.value = undefined;
        }
    }

    self.openImageEditor = function (event, currentImage, newImage) {
        ImageEditor.open(event, currentImage, newImage, 'square', true).then(function (croppedImage) {
            if (croppedImage) {
                self.component.value.file = croppedImage.image;
                self.component.value.fileName = croppedImage.name;
            }
        })
    };

    angular.element($window).bind('resize', function () {
        self.close();
    });
}